/** 10km */
export const DEFAULT_GEO_RANGE: number = 10;
